var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpWashing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.545807,
    y: 0.849121,
    width: 68.6176,
    height: 68.6176,
    rx: 9.80251,
    fill: "#FFF0EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.1871 44.9715C49.5776 44.3714 42.1917 41.5145 40.8515 40.9756C39.5184 40.4461 38.9865 38.9788 38.9865 38.9788C38.9865 38.9788 38.3864 39.3106 38.3864 38.3787C38.3864 37.4456 38.9865 38.9788 39.5866 35.3806C39.5866 35.3806 41.2516 34.9135 40.9209 31.0505H40.5209C40.5209 31.0505 41.521 26.9205 40.5209 25.5226C39.5172 24.1247 39.1242 23.1928 36.9203 22.5245C34.72 21.8573 35.5201 21.9903 33.9222 22.0585C32.322 22.1256 30.99 22.9916 30.99 23.4564C30.99 23.4564 29.9898 23.5235 29.5921 23.9235C29.1921 24.3236 28.5261 26.1874 28.5261 26.6534C28.5261 27.1193 28.8591 30.2539 29.1921 30.9176L28.7955 31.047C28.4625 34.9111 30.1275 35.3794 30.1275 35.3794C30.7276 38.9776 31.3277 37.4445 31.3277 38.3775C31.3277 39.3095 30.7276 38.9776 30.7276 38.9776C30.7276 38.9776 30.1946 40.4437 28.8626 40.9744C27.5306 41.5074 20.1365 44.3714 19.5353 44.9703C18.9352 45.5822 19.0022 48.3779 19.0022 48.3779H50.7178C50.7178 48.3779 50.7919 45.5798 50.1847 44.9692L50.1871 44.9715ZM42.733 47.619H37.3651V46.1482H42.733V47.619Z",
    fill: "#ED5E2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpWashing);
export default __webpack_public_path__ + "static/media/emp_washing.591b131308547d981b6e435ab517e600.svg";
export { ForwardRef as ReactComponent };